import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { LazyImage } from "components"
import { thousandSeparator } from "utils"
import CdsCheckoutSpecifications from "./CdsCheckoutSpecifications"
import classes from "./CdsCheckoutOrderItem.module.scss"

const CdsCheckoutOrderItem = (props) => {
  const { orderItem } = props

  const i18n = useTranslation()[1]

  const totalSpecifications =
    orderItem.specificationItems.reduce((t, specificationItems) =>
      t +=
      specificationItems.salePrice *
      (specificationItems.quantity - specificationItems.freeQuantity)
      , 0
    )

  const total =
    orderItem.quantity * totalSpecifications +
    orderItem.quantity * orderItem.salePrice

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <tr className={classes["card"]}>

      <td>
        <LazyImage
          className={classes["image"]}
          imageWidth={100}
          quality={80}
          src={orderItem.foodImageCover}
          lazy={false}
        />
      </td>

      <td>
        <div>
          {orderItem.foodName}
        </div>

        <div>
          {
            !orderItem.isSimple &&
            <span>
              ({orderItem.optionName})
            </span>
          }
        </div>

        {orderItem.specificationItems.map(specificationItem =>
          <CdsCheckoutSpecifications
            key={specificationItem._id}
            orderItemQuantity={orderItem.quantity}
            specificationItem={specificationItem}
          />
        )}
      </td>

      <td className={classes["quantity"]}>
        {orderItem.quantity}
      </td>

      <td
        className={clsx(
          classes["total"],
          isLtr && classes["total-ltr"]
        )}
      >
        {thousandSeparator(total)}
      </td>
    </tr>
  )
}

export default CdsCheckoutOrderItem